module.exports = __webpack_public_path__ + "media/icons/naped-4-4-7be80803.png";